module.exports = __webpack_public_path__ + "static/media/wallet.8769f5e6.svg";